export type SupervisiIbsHasil = "ya" | "tidak" | "na" | null;

export type SupervisiIbsKategori =
  | "kebersihan-tangan"
  | "apd"
  | "limbah"
  | "pengendalian-lingkungan"
  | "linen"
  | "alat-pelayanan"
  | "kesehatan-karyawan"
  | "penyuntikan-aman"
  | "penempatan-pasien"
  | "lumbal-punksi"
  | "kewaspadaan-transmisi";

export type SupervisiIbsJenis = "rutin" | "insidental" | "follow-up" | "icra";

export type SupervisiIbsVentilasi =
  | "konvensional"
  | "laminar-vertical"
  | "laminar-horizontal"
  | "hepa-only"
  | null;

export interface SupervisiIbsItem {
  id: number;
  kategori: SupervisiIbsKategori;
  item_key: string;
  item_label: string;
  urutan: number;
  hasil: SupervisiIbsHasil;
  masalah: string | null;
  rekomendasi: string | null;
}

export interface SupervisiIbsObservasi {
  id?: number;
  label_ruang: string;
  suhu_c: number | null;
  kelembaban_rh: number | null;
  tekanan_pa: number | null;
  ach: number | null;
  jenis_ventilasi: SupervisiIbsVentilasi;
  hepa_ganti_terakhir: string | null;
  monitoring_terdokumentasi: boolean | null;
  catatan: string | null;
}

export interface SupervisiIbsSectionScore {
  kategori: SupervisiIbsKategori;
  label: string;
  ya: number;
  tidak: number;
  dinilai: number;
  skor: number | null;
  kategori_kepatuhan: string | null;
}

export interface SupervisiIbsScoring {
  per_section: SupervisiIbsSectionScore[];
  total_ya: number;
  total_dinilai: number;
  skor_total: number | null;
  kategori_kepatuhan: string | null;
}

export interface UserRef {
  id: number;
  nama: string | null;
}

export interface SupervisiIbs {
  id: number;
  nomor_formulir: string | null;
  tanggal_supervisi: string;
  waktu_mulai: string | null;
  waktu_selesai: string | null;
  jenis_supervisi: SupervisiIbsJenis;
  unit_nama: string | null;
  sub_lokasi: string | null;

  supervisor_user_id: number;
  supervisor: UserRef | null;
  supervisor_jabatan: string | null;
  signed_supervisor: boolean;
  signed_supervisor_at: string | null;

  kepala_unit_user_id: number | null;
  kepala_unit: UserRef | null;
  kepala_unit_nama_manual: string | null;
  signed_kepala_unit: boolean;
  signed_kepala_unit_at: string | null;

  ketua_ppi_user_id: number | null;
  ketua_ppi: UserRef | null;
  ketua_ppi_nama_manual: string | null;
  signed_ketua_ppi: boolean;
  signed_ketua_ppi_at: string | null;

  temuan_utama: string | null;
  rencana_tindak_lanjut: string | null;
  rekomendasi_direktur: string | null;

  scoring: SupervisiIbsScoring | null;
  is_locked: boolean;
  items?: SupervisiIbsItem[];
  observasi?: SupervisiIbsObservasi[];

  created_at: string;
  updated_at: string;
}

export const KATEGORI_LABEL: Record<SupervisiIbsKategori, string> = {
  "kebersihan-tangan": "I. Supervisi Kebersihan Tangan",
  apd: "II. Supervisi Penggunaan APD",
  limbah: "III. Supervisi Pengelolaan Limbah",
  "pengendalian-lingkungan": "IV. Supervisi Pengendalian Lingkungan",
  linen: "V. Supervisi Pengelolaan Linen",
  "alat-pelayanan": "VI. Supervisi Pengelolaan Alat Pelayanan Pasien",
  "kesehatan-karyawan": "VII. Supervisi Kesehatan Karyawan & Pajanan",
  "penyuntikan-aman": "VIII. Supervisi Penyuntikan yang Aman",
  "penempatan-pasien": "IX. Supervisi Penempatan Pasien",
  "lumbal-punksi": "X. Supervisi Prosedur Lumbal Punksi",
  "kewaspadaan-transmisi": "XI. Supervisi Kewaspadaan Berdasarkan Transmisi",
};

export const KATEGORI_ORDER: SupervisiIbsKategori[] = [
  "kebersihan-tangan",
  "apd",
  "limbah",
  "pengendalian-lingkungan",
  "linen",
  "alat-pelayanan",
  "kesehatan-karyawan",
  "penyuntikan-aman",
  "penempatan-pasien",
  "lumbal-punksi",
  "kewaspadaan-transmisi",
];

export const JENIS_SUPERVISI_OPTS = [
  { text: "Rutin (bulanan)", value: "rutin" },
  { text: "Insidental (outbreak/complaint)", value: "insidental" },
  { text: "Follow-up (re-audit)", value: "follow-up" },
  { text: "ICRA (pra/pasca renovasi)", value: "icra" },
];

export const VENTILASI_OPTS = [
  { text: "Konvensional", value: "konvensional" },
  { text: "Laminar Vertikal", value: "laminar-vertical" },
  { text: "Laminar Horizontal", value: "laminar-horizontal" },
  { text: "HEPA-only", value: "hepa-only" },
];

export const JABATAN_SUPERVISOR_OPTS = [
  { text: "IPCN", value: "IPCN" },
  { text: "IPCLN", value: "IPCLN" },
  { text: "Ketua Komite PPI", value: "Ketua Komite PPI" },
  { text: "Anggota Komite PPI", value: "Anggota Komite PPI" },
];

export const KATEGORI_KEPATUHAN_LABEL: Record<string, string> = {
  sangat_baik: "Sangat Baik",
  baik: "Baik",
  cukup: "Cukup",
  perlu_perbaikan: "Perlu Perbaikan",
};

export function kategoriKepatuhanColor(kat: string | null): string {
  if (kat === "sangat_baik") return "green darken-1";
  if (kat === "baik") return "light-green darken-1";
  if (kat === "cukup") return "orange darken-1";
  if (kat === "perlu_perbaikan") return "red darken-1";
  return "grey";
}
